module.exports = __webpack_public_path__ + "static/media/rejected.1c7f8a16.svg";